module.exports = __webpack_public_path__ + "static/media/Naviglio_turquoise.8f74eb59.jpg";